import axios from "@/api/axiosInstance";
import {
  PlaceProductStoreOrderRequest,
  PlaceProductStoreOrderResponse,
} from "./types";

export const placeProductStoreOrder = async (
  data: PlaceProductStoreOrderRequest,
): Promise<PlaceProductStoreOrderResponse> => {
  const response = await axios.post<PlaceProductStoreOrderResponse>(
    "/api/private/product-store/place-order",
    data,
  );
  return response.data;
};
